<section class="section-welcome container">
    <div class="d-flex">
        <div class="content-left">
            <h1>Entenda como você pode gerenciar <br>
                as suas preferências e o uso dos seus dados
            </h1>
            <h2>1) Quero evitar receber propagandas indesejadas</h2>
            <p>Você pode seguir alguns passos para deixar de receber anúncios online,
                comunicações por e-mail e mala direta ou ligações de telemarketing.
                <br><br>
                Assim, veja algumas instruções para deixar de receber cada tipo de propaganda:</p>
        </div>
        <div class="content-right hidden-xs">
            <img src="assets/illustration-pc.svg" alt="Ilustração - Conheça seus direitos">
        </div>
    </div>
    <div class="button-area">
        <button class="btn-white" *ngFor="let button of actionButtons" (click)="showModal(button.buttonTitle, button.buttonDescription, button.buttonDisclaimer)">{{button.buttonTitle}}</button>
    </div>
</section>
<div class="gray-area">
    <div class="container">
        <div class="message-area">
            <h2>2) Não quero que empresas clientes ou parceiras da Serasa Experian tenham acesso aos meus dados para o
                direcionamento de ofertas de acordo com o meu perfil.</h2>
            <h3>Na Serasa Experian, a escolha será sua!</h3>
            <p>Você poderá solicitar a interrupção ou a retomada do tratamento dos seus dados pessoais em soluções de
                direcionamento de ofertas.
                <br><br>
                A interrupção do tratamento dos seus dados pessoais nas soluções da Serasa Experian para que empresas
                clientes e parceiras direcionem ofertas e comunicações, não impede que as empresas tenham acesso a seus
                dados por outros provedores de serviços.
                <br><br>
                Caso você não concorde com os Termos de Uso e Política de Privacidade da Serasa e queira acessar
                    exclusivamente os seus dados pessoais e mais serviços de Proteção de Dados Pessoais, <a class="link"
                      (click)="showModalMaisInformacoes()">clique aqui</a>.
                <br><br>
                Para fazer a sua opção e garantir a segurança da informação, é necessário estar logado no nosso site.
            </p>
            <button *ngIf="!userIsLoggedIn" class="login-btn" (click)="redirectLogin()">Entrar</button>
        </div>
        <div class="option-box" [ngClass]="{active: userIsLoggedIn, inactive: !userIsLoggedIn}">
            <div class="icon-info">
                <img *ngIf="!userIsLoggedIn" src="assets/icon-info-inactive.svg" alt="informação">
                <img *ngIf="userIsLoggedIn" src="assets/icon-info-active.png" alt="informação">
            </div>
            <div class="protocol-message" *ngIf="userOptOpenProtocol">
                <i><img src="assets/icon-round-check-circle-green.svg" alt="check-icon"></i>
                <div class="text">
                    <strong>Seu protocolo é o {{userOptProtocolNumber}}.</strong>
                    <p>Sua solicitação feita em {{userOptLastUpdate | date: 'dd/MM/yyyy'}} será atendida em até 10 dias</p>
                </div>
            </div>

            <div *ngIf="!userOptOpenProtocol">
                <div class="check" *ngIf="userOptStatus == 'optin' || !userIsLoggedIn || (userOptStatus != 'optin' && userOptStatus != 'optout')">
                    <input spellcheck="false"type="checkbox" name="opt1" id="check-1" [ngModel]="optionOneActive" [ngClass]="{active: optionOneActive, inactive: !optionOneActive}" (change)="optionOneActive = !optionOneActive" (click)="selectOption(1);">
                    <p><strong>Quero interromper o tratamento e compartilhamento dos meus dados pessoais pela Serasa Experian</strong>
                        exclusivamente para a finalidade de direcionamento de ofertas.</p>
                </div>

                <div class="check" *ngIf="userOptStatus == 'optout' || !userIsLoggedIn">
                    <input spellcheck="false"type="checkbox" name="opt2" id="check-2" [ngModel]="optionTwoActive" [ngClass]="{active: optionTwoActive, inactive: !optionTwoActive}" (change)="optionTwoActive = !optionTwoActive" (click)="selectOption(2);">
                    <p>Quero retomar o tratamento e compartilhamento dos meus dados pessoais nas soluções de direcionamento de ofertas da Serasa Experian.</p>
                </div>

                <div class="switch" *ngIf="userOptStatus == 'optin' || !userIsLoggedIn || (userOptStatus != 'optin' && userOptStatus != 'optout')">
                    <div class="switch-btn" [ngClass]="{active: optionOneActive, inactive: !optionOneActive}" (click)="optionOneActive = !optionOneActive; selectOption(1)">
                        <div class="circle"></div>
                    </div>
                    <p><strong>Quero interromper o tratamento e compartilhamento dos meus dados pessoais pela Serasa Experian</strong>
                        exclusivamente para a finalidade de direcionamento de ofertas.</p>
                </div>

                <div class="switch" *ngIf="userOptStatus == 'optout' || !userIsLoggedIn">
                    <div class="switch-btn" [ngClass]="{active: optionTwoActive, inactive: !optionTwoActive}" (click)="optionTwoActive = !optionTwoActive; selectOption(2)">
                        <div class="circle"></div>
                    </div>
                    <p>Quero retomar o tratamento e compartilhamento dos meus dados pessoais nas soluções de direcionamento de ofertas da Serasa Experian.</p>
                </div>

                <div *ngIf="(userOptStatus == 'optin' && userIsLoggedIn) || (userOptStatus != 'optin' && userOptStatus != 'optout' && userIsLoggedIn)">
                    <span>É importante ressaltar que:</span>
                    <ul>
                        <li>Os seus dados pessoais não serão compartilhados com terceiros para essa finalidade</li>
                        <li>Essa ação não afetará as comunicações que você optou por receber, caso tenha uma conta na Serasa
                            Experian (visualização de relatórios ou pontuação de crédito, por exemplo);</li>
                        <li>A interrupção do tratamento desses dados para soluções de direcionamento de ofertas não implica a
                            interrupção do tratamento dos dados para a finalidade de proteção do crédito, autenticação e
                            prevenção a fraudes, e aprimoramento da qualidade de dados.</li>
                    </ul>
                </div>

                <div *ngIf="userOptStatus == 'optout' && userIsLoggedIn">
                    <span>É importante ressaltar que:</span>
                    <ul>
                        <li>Os seus dados pessoais poderão ser compartilhados com terceiros para essa finalidade</li>
                        <li>Essa ação não afetará as comunicações que você optou por receber, caso tenha uma conta na Serasa Experian (visualização de relatórios ou pontuação de crédito, por exemplo)</li>
                    </ul>
                </div>
            </div>

            <div *ngIf="!userOptOpenProtocol">
                <button *ngIf="(!optionOneActive && !optionTwoActive) || !userIsLoggedIn" class="confirm-btn disabled" disabled="disabled">Confirmar</button>
                <button *ngIf="(optionOneActive || optionTwoActive) && userIsLoggedIn" class="confirm-btn enabled" (click)="changeUserStatus()">Confirmar</button>
            </div>
        </div>
    </div>
</div>
<app-modal-erro #modalErro [titulo]="'Ops'" [mensagem]="'Consentimento poderá ser coletado apenas via termo de uso no Serasa Consumidor.'" [hidden]="ocultarModalErro" ></app-modal-erro>
<app-footer-lgpd></app-footer-lgpd>
<app-modal-sidebar></app-modal-sidebar>

